import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import MDTypography from "components/MDTypography";
import { useTranslation } from "react-i18next";

const NetworkError = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={true} maxWidth={"xl"}>
      <DialogContent>
        <MDTypography>{t("session.networkErrorMessage")}</MDTypography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("buttonTitles.close")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default NetworkError;
